export enum ResumeSpecificationMessageCodeEnum {
    ResumePreviousClaim = 'KVOR',
    ResumeSimilarClaim = '11650-43',
}
